<template>
    <div class="flat-crm-card" v-if="cardData != null">
        <breadcrumbs></breadcrumbs>
        <div class="container">
            <!-- Мобильная шапка карточки -->
            <div class="card-header-mobile" v-if="isMobile">
                <div class="card-title">
                    <h1 :class="{'one' : cardData.rooms == 1}"><span>{{cardData.rooms}}<b v-if="cardData.rooms != 1">-x</b></span> комнатная квартира</h1>
                    <!-- , {{cardData.area}} <b>м²</b> -->
                    <!-- @click.prevent="sendToFavorite(item.project_name.name), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.project_name.name)}" -->
                    <div class="btn-to-favorite">
                        <a href="#" class="favorite-link" @click.prevent="sendToFavorite(cardData.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(cardData.id)}">
                            <svg-icon icon-class="star" className="icon-star"/>
                        </a>
                    </div>
                </div>
                <div class="card-complex" v-if="complexData != null">
                    <h2>Жилой комплекс</h2>
                    <div class="complex-info">
                        <div class="complex-logo">
                            <img :src="complexData.logo_color" alt="">
                        </div>
                        <div class="complex-info-right">
                            <p>{{complexData.city_name.name}}</p>
                            <a href="#" :class="{'active' : cardContent == 'map'}" @click.prevent="cardContent = 'map'">КОМПЛЕКС НА КАРТЕ</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end мобильная шапка карточки -->
            <div class="flat-card-info">
                <div class="col-left">
                    <div class="col-navigation">
                        <ul>
                            <li><a href="#" :class="{'active' : cardContent == 'image'}" @click.prevent="cardContent = 'image'">Планировка</a></li>
                            <li><a href="#" :class="{'active' : cardContent == 'consult'}" @click.prevent="cardContent = 'consult', buildFormDataParams(cardData)">Получить консультацию</a></li>
                        </ul>
                    </div>
                    <div class="col-content">
                        <div class="card-img" v-if="cardContent == 'image'">
                            <div class="img-in" v-if="cardData.images.length > 0">
                                <img :src="ucoCRMurl + '/rest/prices/getImage?imageId=' + pic.id" alt="" v-for="pic in cardData.images" v-if="pic.typeCode == '1'">
                            </div>
                            <div class="btns-to-img">
                                <a href="#" class="loop-img link-default" @click.prevent="openLoopCardImg(cardData.images)" v-if="cardData.images.length > 0">
                                    <svg-icon icon-class="loop" className="svg-icon icon-loop"/>
                                </a>
                            </div>
                        </div>
                        <div class="card-consult" v-if="cardContent == 'consult' && formDataParams != null">
                            <flatsCardForm :formData="formDataParams"></flatsCardForm>
                        </div>
                        <div class="card-map" v-if="cardContent == 'map' && complexData != null">
                            <flatsCardMap :cardData="complexData"></flatsCardMap>
                        </div>
                    </div>
                    <div class="col-left-bot">
                        <div class="card-images">
                            <img :src="ucoCRMurl + '/rest/prices/getImage?imageId=' + pic.id" alt="" v-for="pic in cardData.images" v-if="pic.typeCode != '1' && pic.typeCode != '5'">
                        </div>
                        <div class="col-left-bot-links" v-if="!isMobile">
                            <a href="#" v-if="pdf != null" class="card-link send mail">
                                <svg-icon icon-class="mail" className="icon-mail"/>
                                <span>Получить на почту</span>
                            </a>
                            <a :href="ucoCRMurl + '/rest/prices/getImage?imageId=' + pdf" download target="_blank" v-if="pdf != null" class="card-link donwload-pdf">
                                <svg-icon icon-class="print" className="icon-print"/>
                                <span>СКАЧАТЬ ПЛАНИРОВКУ</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="card-title" v-if="!isMobile">
                        <h1 :class="{'one' : cardData.rooms == 1}"><span>{{cardData.rooms}}<b v-if="cardData.rooms != 1">-x</b></span> комнатная квартира</h1>
                        <!-- , {{cardData.area}} <b>м²</b> -->
                        <!-- @click.prevent="sendToFavorite(item.project_name.name), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.project_name.name)}" -->
                        <div class="btn-to-favorite">
                            <a href="#" class="favorite-link" @click.prevent="sendToFavorite(cardData.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(cardData.id)}">
                                <svg-icon icon-class="star" className="icon-star"/>
                            </a>
                        </div>
                    </div>
                    <div class="card-complex" v-if="complexData != null && !isMobile">
                        <h2>Жилой комплекс</h2>
                        <div class="complex-info">
                            <div class="complex-logo">
                                <img :src="complexData.logo_color" alt="">
                            </div>
                            <div class="complex-info-right">
                                <p>{{complexData.city_name.name}}</p>
                                <a href="#" :class="{'active' : cardContent == 'map'}" @click.prevent="cardContent = 'map'">КОМПЛЕКС НА КАРТЕ</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-info">
                        <ul>
                            <li>
                                <div class="left">
                                    Объект
                                </div>
                                <div class="right" v-if="cardData.complexCode != 'LDM'">
                                    {{cardData.complexName.replace(/['"]+/g, '')}}
                                </div>
                                <div class="right" v-else>
                                    {{cardData.complexName.replace(/\,.*/,'')}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    Площадь
                                </div>
                                <div class="right">
                                    {{cardData.area}} <span>м²</span>
                                </div>
                            </li>
                            <li class="price" v-if="cardData.showPricesOnSaleSite == true">
                                <div class="left">
                                    Цена м²
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(cardData.meterPrice)}} <span>тыс.тг</span>
                                </div>
                            </li>
                            <li class="price" v-if="cardData.showPricesOnSaleSite == true">
                                <div class="left">
                                    Стоимость
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(cardData.totalPrice)}} <span>млн.тг</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    Этаж
                                </div>
                                <div class="right">
                                    {{cardData.floor}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    Кв. №
                                </div>
                                <div class="right">
                                    {{cardData.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    <span v-if="cardData.complexCode != 'SOH'">Пятно</span>
                                    <span v-else>Квартал</span>
                                </div>
                                <div class="right" v-if="cardData.complexCode != 'DSV' && cardData.complexCode != 'LDM' && cardData.complexCode != 'SOH' && cardData.complexCode != 'MNC'">
                                    {{getNumbersOfString(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'DSV'">
                                    {{getNumbersOfBlockDiscovery(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'LDM'">
                                    {{getNumbersOfBlockLandmark(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(cardData.blockName)}}
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'MNC'">
                                    {{getNumbersOfBlockMonaco(cardData.blockName)}}
                                </div>
                            </li>
                            <li v-if="blockPart != null">
                                <div class="left">
                                    <span v-if="cardData.complexCode != 'SOH' && cardData.complexCode != 'MNC'">Очередь</span>
                                    <span v-else>Блок</span>
                                </div>
                                <div class="right" v-if="cardData.complexCode == 'LDM' || cardData.complexCode == 'SOH' || cardData.complexCode == 'MNC'">
                                    {{ blockPart }}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Мобильные кнопки -->
                    <div class="col-left-bot-links-mobile" v-if="isMobile">
                        <!-- <a href="#" v-if="pdf != null" class="card-link send mail">
                            <svg-icon icon-class="mail" className="icon-mail"/>
                            <span>Получить на почту</span>
                        </a> -->
                        <a :href="ucoCRMurl + '/rest/prices/getImage?imageId=' + pdf" download target="_blank" v-if="pdf != null" class="card-link donwload-pdf">
                            <svg-icon icon-class="print" className="icon-print"/>
                            <span>СКАЧАТЬ ПЛАНИРОВКУ</span>
                        </a>
                    </div>
                    <!-- {{complexData}} -->
                    <!-- end мобильные кнопки -->
                    <div class="card-links" v-if="complexData != null">
                        <!-- {{complexData.project_name.slug }}
                        {{cardData.blockName}} -->
                        <div class="links">
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR)"
                                v-if="checkConfirmPurchase('book', cardData.complexCode, cardData.blockName)"
                                >Забронировать
                            </a>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR" class="by" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR)" 
                                v-if="checkConfirmPurchase('by', cardData.complexCode, cardData.blockName)"
                                >Купить
                            </a>
                        </div>
                    </div>
                    <!-- <div class="card-links" v-if="complexData != null">
                        <a :href="'https://bazis-a.rocketfirm.digital/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR" class="bron" target="_blank" @click.prevent="linkToLogin('https://bazis-a.rocketfirm.digital/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=book&lang=' + langVAR)">Забронировать</a>
                        <a :href="'https://bazis-a.rocketfirm.digital/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR" class="by" target="_blank" @click.prevent="linkToLogin('https://bazis-a.rocketfirm.digital/?apartment_id=' + cardData.id + '&city=' + complexData.city_name.slug + '&method=by&lang=' + langVAR)">Купить</a>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="container container-share">
            <sharePostBottom class="flat-card-social-bottom" :options="[{title: 'Поделиться планировкой:', data_title: cardData.rooms + ' комнатная квартира, ' + cardData.area + 'м² в ' + cardData.complexName + ' от BAZIS-A', data_link: 'https://sales.bazis.kz/flats/' + cardData.id, data_page: 'flats_card', data_page_key: 'flatsCard'}]"></sharePostBottom>
        </div>
        <flatsViewedSection :cardData="cardData"></flatsViewedSection>
        <flatsCardImg v-if="cardImgVisible"></flatsCardImg>
        <BanerBottomVertical :options="[{page: 'video'}]" class="flat-card-vertical-baner-bottom" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true'"></BanerBottomVertical>
        <transition name="fade" mode="out-in">
            <div class="flats-card-crm-overlay" @click="closeLoopCardImg()" v-cloak v-if="cardImgVisible"></div>
        </transition>
    </div>
</template>

<script>
	import flatsCardImg from '@/components/flats-crm/flats-crm-card-img.vue'
	import flatsCardMap from '@/components/flats-crm/flats-crm-card-map.vue'
	import flatsCardForm from '@/components/forms/form-flats-crm-card.vue'

	import flatsViewedSection from '@/components/flats-crm/flats-crm-viewed-flats.vue'
    import BanerBottomVertical from '@/components/baner-system/baner-bottom-vertical.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import breadcrumbs from '@/components/breadcrumbs/breadcrumbs.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    export default {
        name: 'flat-crm-card',
        components: {
            breadcrumbs,
            sharePostBottom,
            BanerBottomVertical,
            flatsCardImg,
            flatsCardMap,
            flatsCardForm,
            flatsViewedSection,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                cardData: null,
                pdf: null,
                complex: null,
                complexData: null,
                cardContent: 'image',
                formDataParams: null,
                isMobile: false,
                langVAR: window.LangVar,
                blockPart: null,
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItemsDefault',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            cardImgVisible: 'loadVisibleCardImgWindow',
            banerSystem: 'loadBanerSystem',
            URLrocketLC: 'loadUrlRocketLC',
            ucoCRMurl: 'loadUrlCRMuco',
            // flatCard: 'loadFlatCard',
        }),
        methods: {
            openLoopCardImg(data) {
                this.$store.commit('setVisibleCardImgWindow', true);
                this.$store.commit('setCardImgData', data);
                window.body.addClass('overflowTrue');
                document.getElementById('header').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.add('notvisible');
                }
            },
            closeLoopCardImg() {
                this.$store.commit('setVisibleCardImgWindow', false);
                this.$store.commit('setCardImgData', null);
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.remove('notvisible');
                }
            },
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = parseInt(this.blockPart);
                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                if (this.blockPart == null) {
                    this.blockPart = str.split(',')[1];
                    this.blockPart = this.blockPart.replace('Блок', '');
                    this.blockPart = this.blockPart.replace(/ /g, '');

                }
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getPriceForm() {

            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            getIdPDF(arr) {
                var filItem = arr.filter(item => {
                    return item.typeCode == '5'
                });
                if (filItem.length) 
                this.pdf = filItem[0].id;
                // console.log(this.pdf);
            },
            getComplex(code) {
                console.log(code, 'asdasdasd')
                var clean_code = code.replace(/['"]+/g, '').replace('ЖК', '').replace(/\s/g, '');
                var tran_code = this.cyrTolat(clean_code);
                this.complex = tran_code.toLowerCase();
                console.log(this.complex, 'COMPLEX ASADASD')
                if (this.complex == 'jazz') {
                    this.complex = 'jazzkvartal'
                } else if (this.complex == 'millenniumpark') {
                    this.complex = 'mpark'
                } else if (this.complex == 'nurlidala') {
                    this.complex = 'nurly-dala'
                } else if (this.complex == 'remizovkaprivateresidences') {
                    this.complex = 'remizovka'
                } else if (this.complex == 'orionii') {
                    this.complex = 'orion'
                } else if (this.complex == 'landmark3ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'landmark2ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'landmark4ochered') {
                    this.complex = 'landmark'
                } else if (this.complex == 'al-farabi27') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'alfarabi27';
                } else if (this.complex == 'al’farabi27') {
                    this.complex = 'alfarabi27';
                } else if (this.complex == 'rocet') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'alfarabi27';
                } else if (this.complex == 'roketa') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'soho';
                } else if (this.complex == 'roket') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'kohota';
                } else if (this.complex == 'aktau') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'aqualina';
                } else if (this.complex == 'shimkent') { // ТЕСТОВЫЕ ЖК
                    this.complex = 'shahristan';
                } 
                // console.log(clean_code, tran_code, this.complex);
                if (this.projectItems != null) {
                    this.getComplexData();
                }
            },
            getComplexData() {
                // console.log(this.projectItems, this.complex);
                var filterComplex = this.projectItems.filter(item => {
                    return item.project_name.slug == this.complex
                });
                if (filterComplex.length > 0) {
                    this.complexData = filterComplex[0];
                }
                
                // console.log(filterComplex)
            },
            cyrTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            sendToFavorite(id) { // Добавление квартиры в избранное
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('favorite_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('favorite_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectFavorite(id) {
                var items = localStorage.getItem('favorite_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            addCardIDtoStorage(id) { // добавляем id квартиры в хранилище для отправки в онлайн покупки или же вывода в блок вы уже посищяли данные страницы
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                var exist = localStorage.getItem('viewed_flats');
                exist = exist ? exist.split(',') : [];
                var finder = exist.find(item => item == id);
                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('viewed_flats', exist);
                }
                // console.log(exist, localStorage.getItem('viewed_flats'), 'STORAGE FULL');
            },
            buildFormDataParams(arr) {
                // console.log(arr, 'forms');
                this.formDataParams = {
                    'flatID': arr.id,
                    'complex': arr.complexName,
                    'room': arr.rooms,
                    'size': arr.area,
                    'price': arr.meterPrice,
                    'floor': arr.floor,
                    'number': arr.number,
                    'block': arr.blockName,
                }
            },
            linkToLogin(url) {
                // console.log(url);
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // var url = 'https://bazis-a.rocketfirm.net';
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                if (code != 'DSV' && code != 'LDM' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } else if (code == 'LDM') {
                    blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } else if (code == 'MNC') {
                    blockName = this.getNumbersOfBlockMonaco(blockName);
                }
                // console.log(blockName, this.blockPart)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'ALF') { // Настройка кнопок Alfarabi 27
                        if (blockName == '4'  || blockName == '5' || blockName == '6' || blockName == '7') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'EST') { // Настройка кнопок Estet
                        if (blockName == '3' || blockName == '4' || blockName == '5' || blockName == '6' || blockName == '7') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'JAZ') { // Настройка кнопок Jazzkvartal
                        if (blockName == '16' || blockName == '17' || blockName == '18' || blockName == '19' || blockName == '20' || blockName == '21') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LEG') { // Настройка кнопок Legenda
                        if (blockName == '18' || blockName == '20' || blockName == '21' || blockName == '22' || blockName == '23' || blockName == '24' || blockName == '25' || blockName == '26') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'MTR') { // Настройка кнопок Metropole
                        if (blockName == '5' || blockName == '6' || blockName == '7' || blockName == '15') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'ORI') { // Настройка кнопок Orion 3
                        if (blockName == '5') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'PRV') { // Настройка кнопок Primavera
                        if (blockName == '1' || blockName == '2' || blockName == '3' || blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        if (blockName == '12' || blockName == '15' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RIV') { // Настройка кнопок Riviera
                        if (blockName == '14' || blockName == '15' || blockName == '16' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'AUS') { // Настройка кнопок Austria
                        if (blockName == '4' || blockName == '8' || blockName == '10' || blockName == '11') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, 'asdasdasdasdas')
                        if (this.blockPart == 3) {
                            if (blockName == '1') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (this.blockPart == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        
                    } else if (code == 'MNC') { // Настройка кнопок Monaco
                        if (blockName == '5') {
                            if (this.blockPart == 'Б-С5-1') {
                                return true;
                            }
                        } else {
                            return false;
                        }
                        
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        // console.log(blockName, this.blockPart)
                        if (blockName == '2A') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'ALF') { // Настройка кнопок Alfarabi 27
                        if (blockName == '4' || blockName == '5' || blockName == '6' || blockName == '7') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'EST') { // Настройка кнопок Estet
                        if (blockName == '3' || blockName == '4' || blockName == '5' || blockName == '6' || blockName == '7') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'JAZ') { // Настройка кнопок Jazzkvartal
                        if (blockName == '16' || blockName == '17' || blockName == '18' || blockName == '19' || blockName == '20' || blockName == '21') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LEG') { // Настройка кнопок Legenda
                        if (blockName == '22' || blockName == '23' || blockName == '24' || blockName == '25' || blockName == '26') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'MTR') { // Настройка кнопок Metropole
                        if (blockName == '5' || blockName == '6' || blockName == '7' || blockName == '15') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'ORI') { // Настройка кнопок Orion 3
                        if (blockName == '5') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'PRV') { // Настройка кнопок Primavera
                        if (blockName == '1' || blockName == '2') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        return false;
                    } else if (code == 'RIV') { // Настройка кнопок Riviera
                        if (blockName == '14' || blockName == '15' || blockName == '16' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'AUS') { // Настройка кнопок Austria
                        if (blockName == '4' || blockName == '8' || blockName == '10' || blockName == '11') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        if (this.blockPart == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else if (code == 'MNC') { // Настройка кнопок Monaco
                        if (blockName == '5') {
                            if (this.blockPart == 'Б-С5-1') {
                                return true;
                            }
                        } else {
                            return false;
                        }
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.blockPart == 'А1' || this.blockPart == 'А2' || this.blockPart == 'А3' || this.blockPart == 'А4' || this.blockPart == 'А5' || this.blockPart == 'А6' || this.blockPart == 'А7' || this.blockPart == 'А8' || this.blockPart == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }

                } else {
                    return false;
                }
            },
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }
            }, 
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeRouteEnter (to, from, next) {
            // console.log(to.params.id)
            // console.log(to);
            var dataResp = {
                "apartmentIds": [to.params.id]
            };
            if (store.state.projectItems == null) {
                store.dispatch('getProjectsItems');
            }
            axios.post(window.CRMurl + '/rest/prices/getApartments', dataResp).then(async (response) => {
                // console.log(response, 'FLAT CARD');
                if (response.data.data != 0) {
                    next(vm => {
                        vm.cardData = response.data.data[0];
                        vm.addCardIDtoStorage(vm.cardData.id);
                        vm.getIdPDF(vm.cardData.images);
                        vm.getComplex(vm.cardData.complexName);
                        vm.isMobileCheck();
                        vm.checkResize();
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done();
                    });
                } else {
                    next('/flats', vm => {});
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
            document.body.dataset.page = 'flats-crm-card';
        },
        created () {
        },
        mounted () {
            this.$store.watch(
                (state) => state.projectItems,
                (newValue) => {
                    if (newValue) {
                       this.getComplexData();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-card-respond.scss';
    // @import '@/styles/components/flats-page/flats-card.scss';
    // @import '@/styles/components/flats-page/respond/flats-card-respond.scss';
</style>